import { ComponentRoute } from '@/classes'

const PaymentEntryRoutes = {
  PaymentEntryListView: new ComponentRoute('/paymententry', 'PaymentEntryListView'),
  PaymentEntryView: new ComponentRoute('/paymententry/:vendorId', 'PaymentEntryView'),
  PaymentEntryDetail: new ComponentRoute('/paymententry/:vendorId', 'PaymentEntryDetail')
}

export default PaymentEntryRoutes
